export default __webpack_public_path__ + "static/media/crow.74862410.png";